import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when a group is contained in several groups.
 *
 * @param {string} spec.account - Account number that is used more than once
 */
export default class DuplicateAccountValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor({ account }) {
		super(...arguments);

		this._account = account;
	}

	getAccount() {
		return this._account;
	}

	getMessage() {
		return _('Account "{account}" is used multiple times', {
			account: this._account,
		});
	}

	static getType() {
		return "DuplicateAccountValidationResult";
	}
}
